import React from 'react';

interface LogoutWarningModalProps {
  isOpen: boolean;
  countdown: number;
  onDismiss: () => void;
}

export const LogoutWarningModal: React.FC<LogoutWarningModalProps> = ({
  isOpen,
  countdown,
  onDismiss
}) => {
  if (!isOpen) {return null;}

  return (
    <div className="logout-warning-overlay" onClick={onDismiss}>
      <div className="logout-warning-modal" onClick={(e) => e.stopPropagation()}>
        <div className="logout-warning-icon">
          <i className="fa-solid fa-clock"></i>
        </div>
        <h2>Du bliver snart logget ud</h2>
        <p>På grund af inaktivitet bliver du logget ud om:</p>
        <div className="countdown-display">{countdown} sekunder</div>
        <button className="btn btn-primary" onClick={onDismiss}>
          Forbliv logget ind
        </button>
      </div>
    </div>
  );
};